import request from "../../../../helper/request";

const clientBillingApi = {
  // Get all facturas for the current client
  getFacturas: (params = {}) => {
    return request.get("facturas", { params });
  },

  // Get single factura by ID (limited to client's own facturas)
  getFactura: (id) => {
    return request.get(`facturas/${id}`);
  },

  // Get factura logs (limited to client's own facturas)
  getFacturaLogs: (facturaId) => {
    return request.get(`facturas/${facturaId}/logs`);
  },

  // Get all billing logs for the current client
  getBillingLogs: (params = {}) => {
    return request.get(`facturas/logs/billing`, { params });
  },

  // Pay invoice via Stripe (client-side)
  payInvoice: (facturaId) => {
    return request.post(`facturas/${facturaId}/pay`);
  },

  // Pay partial amount via Stripe (client-side)
  payPartialInvoice: (facturaId, amount, note) => {
    return request.post(`facturas/${facturaId}/pay-partial`, { amount, note });
  },

  // Pay all invoices via Stripe (client-side)
  payAllInvoices: (invoiceIds, summary) => {
    return request.post(`facturas/pay-all`, { invoiceIds, summary });
  },

  // Export factura PDF
  exportFacturaPdf: (facturaId) => {
    return request.get(`facturas/${facturaId}/export-pdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" }
    });
  },

  // Get all available entitlements
  getEntitlements: () => {
    return request.get("billing/entitlements");
  },

  // Get client's entitlements with status
  getClientEntitlements: () => {
    return request.get("billing/client-entitlements");
  },

  // Update client entitlement status
  updateClientEntitlement: (entitlementId, isActive, settings) => {
    return request.put("billing/client-entitlements", {
      entitlementId,
      isActive,
      settings
    });
  },

  // Get current month SMS usage
  getCurrentMonthSmsUsage: () => {
    return request.get("billing/sms-usage/current-month");
  },

  // Get all active tiers (excluding "Managed" tier)
  getTiers: () => {
    return request.get("billing/tiers");
  },

  // Update client tier
  updateClientTier: (tierId) => {
    return request.patch("billing/client-tier", { tierId });
  },

  // Sync tier entitlements to client
  syncTierEntitlements: () => {
    return request.post("billing/sync-tier-entitlements");
  }
};

export default clientBillingApi;
